import { Section, TextBlock } from "./section";

interface DescriptionData {
  assetDescription: string | null;
  construction: string | null;
  recreationalFeatures: string | null;
  retainingWalls: string | null;
  specialFeatures: string | null;
  features: string | null;
  detailedDescription: string | null;
}

export function SectionDescription({ data }: { data: DescriptionData }): React.ReactElement {
  return (
    <Section id="description" title="Property Description">
      <div className="space-y-3">
        <TextBlock label="Asset Description" value={data.assetDescription} />
        <TextBlock label="Construction" value={data.construction} />
        <TextBlock label="Recreational Features" value={data.recreationalFeatures} />
        <TextBlock label="Retaining Walls" value={data.retainingWalls} />
        <TextBlock label="Special Features" value={data.specialFeatures} />
        <TextBlock label="Features" value={data.features} />
        <TextBlock label="Detailed Description of Improvements" value={data.detailedDescription} />
      </div>
    </Section>
  );
}
